import { Component, HostListener, Inject, Input, OnInit, HostBinding, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { BrowserENV, UI_BROWSER_ENV } from '../../helper';
import { ListActivatedService } from '../../list/index';
import { PullDownRefreshController, PullUpLoadController } from '../../scroll/index';
import { ActionSheetService, ContentLoadingController } from '../../other/index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ui-app',
  templateUrl: './app.component.html',
  providers: [
    PullDownRefreshController,
    PullUpLoadController,
    ActionSheetService,
    ContentLoadingController
  ]
})
export class AppComponent implements OnInit {
  /**
   * æ ¹æ®ä¸åçå±å¹å®½åº¦ï¼è®¾ç½® html åç´ ç font-size
   * ä¸»è¦ç¨äº rem å¸å±ï¼é»è®¤ä¸º 10
   */
  @Input() baseFontSize: number = 10;
  /**
   * å±å¹ X è½´é»è®¤é»è¾åç´ 
   */
  @Input() screenWidth = 375;

  // æ ¹æ®ä¸åç¯å¢ï¼éè¦æé¡µé¢å¤´é¨å¢é«ç¸å¯¹å°ºå¯¸ï¼ä»¥æ¾ç¤ºæ¶é´ï¼çµæ± çµéç­ä¿¡æ¯ï¼è¿ééè¿æ ·å¼æ¥æ§å¶
  @HostBinding('class.ui-iphone')
  get isIphone() {
    return this.env === BrowserENV.iphone;
  }

  @HostBinding('class.ui-iphone-x')
  get isIphoneX() {
    return this.env === BrowserENV.iphoneX;
  }

  @HostBinding('class.ui-android')
  get isAndroid() {
    return this.env === BrowserENV.android;
  }

  @HostBinding('class.ui-default')
  get isDefault() {
    return this.env === BrowserENV.default;
  }

  private htmlElement: HTMLElement;
  private subs: Subscription[] = [];

  constructor(@Inject(DOCUMENT) private document: any,
              @Inject(UI_BROWSER_ENV) private env: BrowserENV,
              private elementRef: ElementRef,
              private actionSheetService: ActionSheetService,
              private listActivatedService: ListActivatedService) {
  }

  ngOnInit() {
    this.htmlElement = this.document.querySelector('html');
    this.resize();

    this.subs.push(this.actionSheetService.onInit.subscribe(el => {
      this.elementRef.nativeElement.appendChild(el);
    }));
  }

  @HostListener('window:resize')
  resize() {
    // éè¿å½åè§å£çå®½åº¦ï¼å¨æè®¾ç½® css rem å¼çå¤§å°
    if (!this.htmlElement) {
      return;
    }
    const docWidth = this.htmlElement.getBoundingClientRect().width;
    const scale = docWidth / this.screenWidth;
    this.htmlElement.style.fontSize = `${scale * this.baseFontSize}px`;
  }

  @HostListener('document:touchstart')
  documentTouchStart() {
    // å½é¡µé¢æ list ç»ä»¶æ¶ï¼å¦æå¶ä¸­æä¸é¡¹å·²æå¼ slidingï¼å½ç¨æ·ç¹å»å¶å®å°æ¹æ¶ï¼éè¦åå¸å¨å±äºä»¶ï¼æ¥æ¶èµ· sliding
    this.listActivatedService.publish();
  }
}
